// This is generated.  Alter it in blockGroups/filters/types/ByNavigationSelectionCriteria.js
/* eslint-disable no-unused-vars */
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const { namespace, relation, criteriaProperty, propertyName } = hNode;
    //we don't know much. Hopefully from elsewhere there is a more complete definition.
    //But register what we know regardless, as that helps with finding incorrect configurations

    //we DO know that the navigated relation has a criteria object
    //And in it, there is at least 1 criteria: `propertyName`
    //We do NOT know what criteria operations it can contain.
    // The criteria structure is documented but not enforced in the data dictionary at this level.
    const subDataDictionary = {};

    //we also know that whatever relation context we are in, is expected to have `propertyName` as property
    //but we don't know the type from here, so just mark with propertyName
    const partialTypeDefinition = {
      [propertyName]: {
        'x-propertyName': propertyName,
      },
    };
    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'filters',
  'ByNavigationSelectionCriteria',
  module.exports,
);
